/* import __COLOCATED_TEMPLATE__ from './empty-custom-object-attribute-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();